// extracted by mini-css-extract-plugin
module.exports = {"planComparisonContainer":"styles_planComparisonContainer__JMFkT","title":"styles_title__70qOP","comparisonContainer":"styles_comparisonContainer__RW_yU"};